import { ReadinessCard, ReadinessObject } from '../ReadinessCard';

interface ReadinessCardsGridProps {
  readiness: Array<ReadinessObject> | undefined;
  sso: boolean;
  isMobile?: boolean;
}

export const ReadinessCardsGrid = ({
  readiness,
  sso,
  isMobile,
}: ReadinessCardsGridProps) => {
  if (!readiness || !sso) {
    return (
      <>
        <ReadinessCard />
        <ReadinessCard />
        <ReadinessCard />
      </>
    );
  } else {
    return (
      <>
        {readiness.map((item, index) => {
          return (
            <ReadinessCard
              index={index}
              key={item.id}
              data={item}
              isMobile={isMobile}
            />
          );
        })}
      </>
    );
  }
};
